var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgTiktok = function SvgTiktok(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3333 0H1.66667C0.747667 0 0 0.747667 0 1.66667V12.3333C0 13.2523 0.747667 14 1.66667 14H12.3333C13.2523 14 14 13.2523 14 12.3333V1.66667C14 0.747667 13.2523 0 12.3333 0ZM11.002 6.10767C10.9263 6.11467 10.8497 6.11933 10.772 6.11933C9.89767 6.11933 9.12933 5.66967 8.68233 4.99C8.68233 6.773 8.68233 8.80167 8.68233 8.83567C8.68233 10.4053 7.40967 11.678 5.84 11.678C4.27033 11.678 2.99767 10.4053 2.99767 8.83567C2.99767 7.266 4.27033 5.99333 5.84 5.99333C5.89933 5.99333 5.95733 5.99867 6.01567 6.00233V7.403C5.95733 7.396 5.9 7.38533 5.84 7.38533C5.03867 7.38533 4.38933 8.03467 4.38933 8.836C4.38933 9.63733 5.03867 10.2867 5.84 10.2867C6.64133 10.2867 7.349 9.65533 7.349 8.854C7.349 8.82233 7.363 2.32267 7.363 2.32267H8.70167C8.82767 3.51967 9.794 4.46433 11.002 4.551V6.10767Z",
    fill: "currentColor"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTiktok, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/tiktok.d796e86d.svg";
export { ForwardRef as ReactComponent };